/**
 * VAULT 2.0 · UI Redesign V2 · Feature Flag Hook
 *
 * Reads the central `ui_redesign_v2` feature flag AND applies a
 * hard client-side allowlist: only the founder email (`pd@daga.in`)
 * ever sees the redesign in Preview. Every other user — including
 * every internal QA account and every real customer — continues to
 * see the current LIVE UI, exactly as-is.
 *
 * Progressive rollout is controlled server-side (admin flips
 * `target_kind` when we're ready to expose to internal QA → beta →
 * production). This hook adds a paranoid client-side guard so a
 * misconfigured flag can NEVER push v2 UI to a real customer in
 * this Phase 1 window.
 */
import { useAuth } from "@/contexts/AuthContext";

// Phase-1 allowlist. Emails here always get v2 when the flag is on.
// Keep this list SHORT and audited.
const V2_ALLOWLIST = ["pd@daga.in"];

/**
 * @returns {{ enabled: boolean, isFounder: boolean }}
 */
export function useUiRedesignV2() {
    const { user } = useAuth();
    const email = (user?.email || "").toLowerCase().trim();
    const isFounder = V2_ALLOWLIST.includes(email);

    // Phase 1 gate — founder-only. When we're ready for QA / beta / prod,
    // relax this predicate to read the flag from context / API and combine.
    const enabled = isFounder;

    return { enabled, isFounder };
}
